import { Header } from "@/components/layout/Header";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Plus, Shield } from "lucide-react";

export const AdminPage = () => {
  const navigate = useNavigate();

  const handleAddValueAdd = () => {
    navigate("/admin/value-add");
  };

  const handleIssueRate = () => {
    navigate("/admin/issuerate");
  };

  return (
    <div className="relative flex h-full w-full flex-col">
      <Header
        leftSection={
          <div className="flex flex-row items-center space-x-2">
            <Shield className="h-5 w-5" />
            <p>Admin Dashboard</p>
          </div>
        }
        rightSection={
          <div className="flex space-x-2">
            <Button onClick={handleIssueRate} className="!rounded-lg !bg-[#000] !px-4 !py-2 !text-sm leading-6 !font-medium text-white">
              <p>Issue Rate</p>
            </Button>
            <Button onClick={handleAddValueAdd} className="!rounded-lg !bg-[#000] !px-4 !py-2 !text-sm leading-6 !font-medium text-white">
              <Plus className="h-4 w-4" />
              Add
            </Button>
          </div>
        }
      />
      <div className="flex-1 overflow-auto p-6">
        <div className="space-y-6">
          <div className="rounded-lg bg-white p-6 shadow">
            <h2 className="mb-4 text-xl font-semibold">Admin Dashboard</h2>
            <p className="mb-4 text-gray-600">Welcome to the admin dashboard. Use the buttons above to navigate to different sections.</p>
            <div className="grid grid-cols-2 gap-4">
              <div className="cursor-pointer rounded-lg bg-gray-50 p-6 hover:bg-gray-100" onClick={handleIssueRate}>
                <h3 className="mb-2 text-lg font-semibold">Issue Rate Analytics</h3>
                <p className="text-gray-600">View detailed issue rate charts and analytics data</p>
              </div>
              <div className="cursor-pointer rounded-lg bg-gray-50 p-6 hover:bg-gray-100" onClick={handleAddValueAdd}>
                <h3 className="mb-2 text-lg font-semibold">Value Add Management</h3>
                <p className="text-gray-600">Manage value add configurations and settings</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
